import { useContext } from 'react';
import { InvestigationContext } from '@context/InvestigationContext';

export const useInvestigationDetails = () => {
	const { investigationDetails } = useContext(InvestigationContext);
	return investigationDetails;
};
